module.exports = __webpack_public_path__ + "img/icon_sec4_01.afe0bd7c.png";